import script from "./ResultOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultOrganism.vue?vue&type=script&setup=true&lang=js"

import "./ResultOrganism.vue?vue&type=style&index=0&id=6ee0a65a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee0a65a"]])

export default __exports__